import { setErrorNotification } from 'notifications'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { clearProfile } from 'store/shared/actions'
import { getEmployeeProfile } from 'store/slices/profile/requests'
import { RootState, useAppDispatch } from 'store/store'
import { LoaderWrapper } from 'utils/functions/presenters'
import { UserProfile } from 'utils/types/auth'
import { Profile } from '../../parts/Profile/Profile'
import { withAppLayout } from '../../parts/AppLayout/AppLayout'
import { Helmet } from 'react-helmet-async'
import { AuthState } from 'store/slices/auth'
import {ExtraProfileInfo} from "../../utils/types/profile";

export const ProfilePage = withAppLayout(() => {
    const loadingProfile = useSelector<RootState, boolean>((state) => state.profile.loadingProfile)
    const profile = useSelector<RootState, UserProfile | null | undefined>((state) => state.profile.profile)
    const loadingAdditionalInfo = useSelector<RootState, boolean>((state) => state.profile.loadingAdditionalInfo)
    const extraInfo = useSelector<RootState, ExtraProfileInfo | null | undefined>((state) => state.profile.extraInfo)
    const authInfo = useSelector<RootState, AuthState | null | undefined>((state) => state.auth)

    const { id } = useParams<'id'>()

    const dispatch = useAppDispatch()

    const nothingHere = !loadingProfile && profile === null

    useEffect(() => {
        // if something is not downloaded yet or being downloaded - just let it download fully
        if (!id || !profile || !extraInfo || loadingProfile || loadingAdditionalInfo) return

        // if what is already downloaded is what we need - done
        if ( id===profile.user_id )
            return;

        // start downloading what we need
        dispatch(getEmployeeProfile(id))
        return () => {
            dispatch(clearProfile())
        }
    }, [id,profile,extraInfo,loadingProfile,loadingAdditionalInfo])

    useEffect(() => {
        if (!loadingProfile && profile === null) {
            dispatch(setErrorNotification("Can't get profile"))
        }
    }, [loadingProfile, profile])

    const tabTitle =
      (!profile || (profile?.user_id === authInfo?.user?.user_id)) ? (
            <title>Skills Matrix</title>
        ) : (
            <title>{`${profile?.name} | Skills Matrix`}</title>
        )

    const isLoading=loadingProfile || loadingAdditionalInfo || !profile || id!==profile.user_id;

    return (
        <LoaderWrapper isLoading={isLoading} hasNoContent={nothingHere}>
            <Helmet>{tabTitle}</Helmet>
            <Profile />
        </LoaderWrapper>
    )
})
